export type TextDirection = "rtl" | "ltr";

// ISO codes (as returned by `languageToString`) that render right-to-left.
// Only `he` ships today; `ar` is listed so Arabic works out of the box if it
// is ever added to the supported languages.
const RTL_LANGUAGES: ReadonlySet<string> = new Set(["he", "ar"]);

export function getLanguageDirection(languageCode: string): TextDirection {
  return RTL_LANGUAGES.has(languageCode) ? "rtl" : "ltr";
}
